var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM10.1 4C10.1 2.84 9.16 1.9 8 1.9C6.84 1.9 5.9 2.84 5.9 4C5.9 5.16 6.84 6.1 8 6.1C9.16 6.1 10.1 5.16 10.1 4ZM14.1 13C14.1 12.36 10.97 10.9 8 10.9C5.03 10.9 1.9 12.36 1.9 13V14.1H14.1V13ZM0 13C0 10.34 5.33 9 8 9C10.67 9 16 10.34 16 13V16H0V13Z",
    fill: "#302322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.75dc436d6cf2086335f606a5c95aaecb.svg";
export { ForwardRef as ReactComponent };